import React, { Component } from "react";
import ApiService from "constants/ApiService";
import {
  filterQuery,
  returnThirdDegreeObjValue,
  returnFirstDegreeObjValue,
  showLocaldate,
  displayPrice,
} from "constants/utils";

import {
  Card,
  CardBody,
  CardHeader,
  Table,
  Spinner,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  DropdownMenu,
  DropdownItem,
  InputGroup,
  InputGroupText,
  Button,
} from "reactstrap";
import { displayPercentage } from "constants/utils";
import closeIcon from "../../assets/img/brand/close.svg";
import DateSvg from "../../assets/img/brand/date-pick.svg";
import Select from "react-select";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { showDatenTime } from "constants/utils";

class timeLineSideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeLineData: [],
      isLoading: false,
    };
  }

  componentDidUpdate(prevProps) {
    let { id } = this.props;
    if (prevProps.id !== id) {
      this.setState({ isLoading: true });
      this.setTimeLine();
    }
  }
  setTimeLine = async () => {
    let { id } = this.props;
    let response = await ApiService.getAPI(`contractor/invoice/${id}`);
    if (response.success) {
      this.setState({ timeLineData: response?.data?.invoice?.timeline }, () => {
        this.setState({ isLoading: false });
      });
    } else {
      this.setState({ isLoading: false });
    }
  };

  closeModal = () => {
    this.props.close();
  };

  render() {
    let { timeLineData, isLoading } = this.state;
    let { invoiceDetail } = this.props;
    return (
      <div>
        {this.props.isOpen && (
          <Card className="bnone">
            <CardHeader>
              <div className="flex">
                <div className="fw-500 f16 cl000000">Timeline</div>

                <img
                  src={closeIcon}
                  onClick={() => this.closeModal()}
                  className="point"
                />
              </div>
            </CardHeader>
            <CardBody className="pad30p">
              {isLoading ? (
                <div className="spin-loading3 mt-30">
                  <Spinner type="border" color="#0A8080" />
                </div>
              ) : timeLineData.length > 0 ? (
                timeLineData.map((data) => (
                  <div className="align-left date_info invoiceTimeline">
                    <div className="flexMidColumn mr-20">
                      <div className="timeLineRound"></div>
                      <div className="timeLineVerLine"></div>
                    </div>
                    <div className="flex-column">
                      <div className="f14 mb-15 cl5A5858 fw-500 lh-12">
                        {data.msg}
                      </div>
                      <div
                        className={
                          data?.reason
                            ? "fw-500 f14 linkDiv lh-12 mb-20"
                            : "fw-500 f14 linkDiv lh-12 mb-40"
                        }
                      >
                        {showDatenTime(data.time)}
                      </div>
                      {data?.reason && (
                        <div className=" timelineReason f14 fw-400 mb-35">
                          <span className="f14 fw-500">Reason : </span>
                          {data?.reason}
                        </div>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="align_midd">No Timeline Available</div>
              )}
            </CardBody>
          </Card>
        )}
      </div>
    );
  }
}

export default timeLineSideBar;
